// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","GroupsGrid__row":"rf_a bho_a bho_r bho_sb bho_ry bho_rz","GroupsGrid__row__item":"rf_b bho_be bho_rz"};